import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-blank-layout',
  standalone: true,
  imports:[RouterModule],
  templateUrl: './blank.component.html',
  styleUrls: []
})
export class BlankComponent {}
